// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

// Colors that match the Design System
const majesticColors = {
    primary: "#ad1923",
    primaryAlt: "#e9212e",
    primaryDark: "#393939",
    secondary: "#525156",
    secondaryAlt: "#0e202e",
    tertiary: "#1d1c1c",
    success: "#008566",
    error: "#CC3535",
    warning: "#DC5133",
    info: "#4F758B",
    accentTitle: "#2C2A29",
    text: "#666666",
    link: "#FF5C39",
    black: "#000000",
    white: "#ffffff",
    grey: {
        pale: "#f4f4f4",
        light: "#e5e5e5",
        main: "#393939",
        dark: "#161616",
    },
};

const colors: Styleguide["colors"] = {
    primary: {
        main: majesticColors.primary,
        contrast: majesticColors.white,
        // Custom
        alt: majesticColors.primaryAlt,
        dark: majesticColors.primaryDark,
    },
    secondary: {
        main: majesticColors.secondary,
        contrast: majesticColors.white,
        // Custom
        alt: "#e9212e",
        dark: "#393939",
    },
    tertiary: {
        main: "#1d1c1c",
        contrast: majesticColors.white,
    },
    common: {
        background: majesticColors.white,
        backgroundContrast: majesticColors.text,
        accent: majesticColors.grey.pale,
        accentContrast: majesticColors.text,
        border: "#c6c6c6",
        disabled: "#c6c6c6",
        // Custom
        accentLighter: majesticColors.grey.pale,
        backgroundRgba: "rgba(255, 255, 255, 0.9)",
        borderLight: majesticColors.grey.light,
        borderDark: majesticColors.grey.dark,
        borderColored: majesticColors.primary,
        disabledLighter: "#F8F8F8",
        disabledLight: "#f4f4f4",
        backgroundAlt: "#F4F4F4",
        carouselBackground: "rgba(44, 46, 53, 0.5)", // Store Custom Code
    },
    text: {
        main: "#2C2A29",
        disabled: "#c6c6c6",
        accent: majesticColors.accentTitle,
        link: "#ad1923",
        // Custom
        dark: majesticColors.accentTitle,
        darkest: "#333333",
        linkHover: "#262626",
        input: majesticColors.text,
        inputSearch: majesticColors.grey.light,
        linkAlt: "#ffffff",
        linkAltHover: "#c6c6c6",
    },
    success: {
        main: "#028526",
        contrast: majesticColors.white,
        light: "#E8FDEE",
    },
    danger: {
        main: majesticColors.error,
        contrast: majesticColors.white,
        light: "#FFE9EF",
    },
    warning: {
        main: "#f78830",
        contrast: majesticColors.white,
        light: "#FEF7EA",
        // Store Custom Code
        icon: "#ffff00",
    },

    info: {
        main: "#df1642",
        contrast: majesticColors.white,
        // Custom
        alt: "#DCE2F1",
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#0f0f0f", // None
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#9CA5B2", // Text Color -> Accent
        disabled: "#d6d7dc", // Gray Shades -> Mid
    },
    button: {
        disabled: {
            main: "#d6d7dc", // Gray Shades -> Mid
            contrast: "#ffffff", // Black & White -> White
        },
    },
    header: {
        main: majesticColors.white,
        accent: majesticColors.primary, // Primary -> Main
        accentHover: majesticColors.primaryDark, // Primary -> Dark
    },
    menu: {
        mainNavigation: {
            main: "#ffffff",
            contrast: "#0D2C6B",
            hover: "#2F6E1C",
            accent: "#0D2C6B",
            accentContrast: "#ffffff",
            accentHover: "#0D2C6B",
            border: "#DBE0E6",
        },
        secondaryNavigation: {
            main: "#505D67",
            contrast: "#505D67",
            hover: "#505D67",
        },
    },
    footer: {
        main: "#ffffff", // Gray Shades -> Light
        contrast: "#505D67", // Text Color -> Main
        alt: "#F8F8F8", // Primary -> Main
        altContrast: "#505D67", // None, should match "primary.contrast"
    },
    swatch: {
        main: "#DBE0E6", // Border -> Border
        contrast: "#505D67", // Text Color -> Main
        hover: "#2F6E1C", // Primary -> Main
        selected: "#2F6E1C", // Primary -> Main
        selectedHover: "#505D67", // Primary -> Dark
    },
};

export default colors;
